import React from 'react';
import { useRouter } from 'next/router';
import { useCompaniesHeader, useCompaniesSpecialty } from '@repository/companies/useCompanies';
import classnames from 'classnames/bind';
import styles from './strength.module.scss';
const cx = classnames.bind(styles);

const Strength = () => {
  const router = useRouter();
  const { sn } = router.query;
  const { data } = useCompaniesSpecialty(Number(sn));
  const { data: headerData } = useCompaniesHeader(Number(sn));

  if (!data?.specialtyDtos.length) return null;

  const itemEls = data.specialtyDtos.map((item, index) => {
    return (
      <li key={index} className={cx('strengthText')}>
        <span className={cx('number')}>{index + 1}</span>
        {item.specialty}
      </li>
    );
  });

  return (
    // 강점 리스트 영역
    <div className={cx('snInner', 'strengthInner')}>
      {/* 영역 제목 */}
      <p className={cx('sectionTitle')}>{headerData?.companyHeaderDto.name}의 특별한 강점</p>

      {/* [D] 6가지 카드 속 내용 받기 */}
      <ul className={cx('strengthCard')}>
        {/* 텍스트 keep-all */}
        {itemEls}
      </ul>
    </div>
  );
};

export default Strength;
